export function isLessThan3YearsAt(yearsAt: string, monthsAt: string) {
  return (yearsAt !== "" || monthsAt !== "") && +yearsAt < 3;
}

export function isLessThan6MonthsAt(yearsAt: string, monthsAt: string) {
  return (yearsAt !== "" || monthsAt !== "") && +yearsAt === 0 && +monthsAt < 6;
}
